import { isStringControl, JsonFormsRendererRegistryEntry, rankWith } from '@jsonforms/core';
import controlRenderer from './StringControlRenderer.vue';

export const entry: JsonFormsRendererRegistryEntry = {
  renderer: controlRenderer,
  tester: rankWith(1, isStringControl),
};
